import React, { Component } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';

const DialogContent = styled(MuiDialogContent)`
  && {
    background-color: white;
  }
`;

export default class ReviewDialog extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    mobileDetect: PropTypes.objectOf(PropTypes.any),
    isOpen: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
  };

  static defaultProps = {
    mobileDetect: {}
  };

  static contextTypes = {
    router: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    this.props.handleClose();
  }

  render() {
    const { isOpen, mobileDetect, children } = this.props;

    return (
      <Dialog
        modal={false}
        open={isOpen}
        fullScreen
      >
        <DialogActions>
          <IconButton
            onClick={e => {
              e.stopPropagation();
              this.handleClose();
            }}
          >
            <ClearIcon />
          </IconButton>
        </DialogActions>
        <DialogContent>
          { children }
        </DialogContent>
      </Dialog>
    );
  }
}
